import { createContext, useContext } from 'react';

import * as trackingEvents from './trackingEvents';
import type { Level1Item, Level3Item } from 'client-site-chrome-ui/types/departmentsNav';

interface ContextValue {
  navigationData: Level1Item[];
}

export const TrackingContext = createContext<ContextValue | undefined>(undefined);

export const useTracking = () => {
  const context = useContext(TrackingContext);

  if (context === undefined) {
    throw new Error('useTracking must be used within a TrackingContextProvider');
  }

  const { navigationData } = context;

  return {
    onClickLink: (evt: React.MouseEvent<HTMLAnchorElement>, item: Level3Item) => {
      trackingEvents.clickLink(evt, navigationData, item);
    },
    onMegaNavOpen: (item: Level3Item) => {
      trackingEvents.megaNavOpen(navigationData, item);
    },
  };
};
